import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChessBoard } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';

import { getNumberString } from 'functions/numberToString';
import useCultureCode from 'hooks/redux/useCultureCode';

interface IProps {
	density: number | null;
}

const Density = (props: IProps) => {
	const cultureCode = useCultureCode();
	if (props.density) {
		return (
			<p>
				<span id="icon">
					<FontAwesomeIcon icon={faChessBoard as IconProp} />
				</span>
				<b>{getNumberString(props.density, cultureCode)}</b>
				{` ${t('measurments:GRAMMS_PER_QUBIC_CM')}`}
			</p>
		);
	}
	return <></>;
};

export default Density;
